import { qzTrayClientApi } from "../../api";

/**
 * 🌍 QzTrayClientService
 *
 * Gestiona la obtención de la configuración completa del cliente QZ Tray
 * (host, puerto, SSL, timeout y certificado activo).
 *
 * ✅ Funcionalidad principal:
 * - Obtener la configuración actual desde el backend.
 */
const QzTrayClientService = {
  
  /**
   * ⚙️ Obtener configuración completa de conexión QZ Tray
   * GET /api/qztray/client/config
   */
  getClientConfig: async () => {
    const response = await qzTrayClientApi.fetchCustom(`/config`);
    return response.data;
  },
};

export default QzTrayClientService;
